<script setup>
const year = new Date().getFullYear();
</script>
<template>
  <footer class="page-footer">
    <div class="wrap footrow">
      <div>
        <div style="font-weight:700; color:var(--text); margin-bottom:6px">智慧导读 · HyperReading</div>
        <div>
          © {{year}}
        </div>
        <div>
          <a href="https://www.banpo.com.cn" target="_blank">上海半坡网络搜索有限公司 · Shanghai Banpo Network Technologies Ltd.</a>
        </div>
        <div>
          <a href="https://beian.miit.gov.cn/">沪ICP备11024914号</a>
        </div>
        <div>
          小贴士：按 <span class="kbd">Ctrl</span> / <span class="kbd">⌘</span> + <span class="kbd">F</span> 搜索关键词（RAG
          / 溯源 / 兴趣）。
        </div>
      </div>
      <div class="small-links" aria-label="页脚链接">
        <router-link to="/features">功能</router-link>
        <router-link to="/pricing">版本与定价</router-link>
        <router-link to="/download/app">下载</router-link>
        <router-link to="/apply">机构试用</router-link>
        <router-link to="/faq">FAQ</router-link>
        <router-link to="/partners">代理合作</router-link>
        <router-link to="/tech-coop">技术合作</router-link>
        <router-link to="/company">关于我们</router-link>
      </div>
    </div>
  </footer>
</template>
